module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_face.a0146b0f.png";